import React, { useMemo } from "react";
import ReactDOM from "react-dom";
import { theme } from "./theme";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ResourcesPage } from "./component/resources-page";
import { About } from "./component/about";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Authorize } from "./component/authorize";
import { Detail } from "./component/detail";
import { grey } from "@mui/material/colors";
import { AddResourcePage } from "./component/add-resource-page";
import { ArchivedResourcesPage } from "./component/archived-resources-page";
import { GamePage } from "./component/game-page";
const App = () => {
    const basename = useMemo(() => {
        return process.env.BASENAME || "/";
    }, []);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(CssBaseline, null),
        React.createElement(Router, { basename: basename },
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/game", element: React.createElement(GamePage, null) }),
                React.createElement(Route, { path: "*", element: React.createElement(Authorize, null,
                        React.createElement(Routes, null,
                            React.createElement(Route, { path: "/", element: React.createElement(ResourcesPage, null) }),
                            React.createElement(Route, { path: "/about", element: React.createElement(About, null) }),
                            React.createElement(Route, { path: "/resource/:id", element: React.createElement(Detail, null) }),
                            React.createElement(Route, { path: "/addResource", element: React.createElement(AddResourcePage, null) }),
                            React.createElement(Route, { path: "/archived-resources", element: React.createElement(ArchivedResourcesPage, null) }))) })))));
};
const root = document.createElement("div");
root.style.maxHeight = "100dvh";
root.style.width = "100vw";
root.style.overflow = "hidden";
root.style.display = "flex";
root.style.flexDirection = "column";
document.body.appendChild(root);
document.body.style.margin = "0";
document.body.style.backgroundColor = grey[100];
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(App, null), root);
